import { observable } from 'mobx';
import { KPI } from 'types/kpi';
import { KpiCompany, KpiTemplate } from '../generated/graphql';

export class KPIStore {
  @observable
  kpis: KPI[] = [];

  @observable
  editorKPIs: any[] = [];

  @observable
  kpisByIds = {} as { [key: string]: any };

  @observable
  groupedKPIs = [] as any[];

  @observable
  companies: KpiCompany[] = [];

  @observable
  templates: KpiTemplate[] = [];

  @observable
  editorTemplate = {
    id: '',
    name: '',
    description: '',
    indicators: [] as any[],
  };
}
